<script setup>
import { setQueryParam, setPaginationLinkQueryParams } from '@/Helpers/urlHelper.js'
import { TabGroup, TabList, Tab, TabPanels, TabPanel } from '@headlessui/vue'
import { onMounted } from 'vue'
const props = defineProps({
  tabs: Array,
  selectedTabIndex: String,
})

const changeTab = (tab) => {
  setQueryParam('tabIndex', tab)
  setTimeout(() => {
    setPaginationLinkQueryParams()
  }, 100)
}

onMounted(() => {
  changeTab(props.selectedTabIndex)
})
</script>

<template>
  <TabGroup
    :default-index="parseInt(selectedTabIndex)"
    @change="changeTab"
  >
    <TabPanels class="mt-2">
      <TabPanel
        v-for="tab in tabs"
        :key="tab.key"
        :class="['rounded-xl bg-white py-3', 'ring-yellow focus:outline-none focus:ring-2  container']"
      >
        <slot :name="`${tab.key}-tab`"></slot>
      </TabPanel>
    </TabPanels>
  </TabGroup>
</template>
